export const PIECHARTS = (data:any[]) =>{
    const keys:any = data.length>0 ? Object.keys(data[0]) : [];

    return keys.map((k:any)=>{
        return {name:k, value:data[0][k]}
    })
}

export const COLORS = ['#70AF52', '#E09A05'];